<!--
 * @Author: zhangjingqing
 * @Date: 2022-02-11 17:02:03
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2022-06-16 21:53:52
 * @Description: file content
 * @FilePath: \lcdp-front-web\src\views\userManage\user\Index.vue
-->
<template>
  <div class="container">
    <div class="options">
      <a-space>
        <span v-show="showSystemName" >系统名称</span>
        <a-select v-show="showSystemName" v-model="systemName" placeholder="请选择系统名称" style="width: 180px;">
          <!-- 选项 -->
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="clientType">税智报</a-select-option>
          <a-select-option value="0">税务云</a-select-option>
          <a-select-option value="1">U8</a-select-option>
          <a-select-option value="2">T+</a-select-option>
          <a-select-option value="3">自有</a-select-option>
          <a-select-option value="4">BI</a-select-option>
          <a-select-option value="5">好会计</a-select-option>
          <a-select-option value="6">天津银行</a-select-option>
          <a-select-option value="7">易安税</a-select-option>
        </a-select>
        <a-button type="primary" icon="plus" @click="handleAdd">添加用户</a-button>
        <a-button icon="lock" @click="handleUpdatePsd">修改密码</a-button>
      </a-space>
    </div>
    <a-table
        :columns="columns"
        :data-source="data"
        :row-selection="rowSelection"
        :loading="loading"
        :pagination="{
        current: current,
        pageSize: pageSize,
        total: total,
        showTotal: (total) => `共 ${total} 条数据`
      }"
        @change="handleTableChange"
    >
      <span slot="indexStandardType" slot-scope="indexStandardType">
        <a-tag :key="indexStandardType">
          {{ indexStandardTypeFormatter(indexStandardType) }}
        </a-tag>
      </span>
      <span slot="status" slot-scope="status">
        <a-tag :key="status" :color="status == '1' ? 'green' : 'red'">
          {{ statusFormatter(status) }}
        </a-tag>
      </span>
      <span slot="taxpayerNature" slot-scope="taxpayerNature">
        <a-tag :key="taxpayerNature">
          {{ taxpayerNatureFormatter(taxpayerNature) }}
        </a-tag>
      </span>
      <span slot="industry" slot-scope="industry">
        <a-tag :key="industry">
          {{ industryFormatter(industry) }}
        </a-tag>
      </span>
      <span slot="type" slot-scope="type">
        <a-tag :key="type">
          {{ typeFormatter(type) }}
        </a-tag>
      </span>

      <span slot="createTime" slot-scope="createTime">
        {{ $moment(createTime).format("YYYY-MM-DD") }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
            修改状态<a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a href="javascript:;" @click="handleStatusChange(record.id, 1)"
                >启用</a
              >
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" @click="handleStatusChange(record.id, 2)"
                >禁用</a
              >
            </a-menu-item>
                        <a-menu-item>
              <a href="javascript:;" @click="handleDelete(record.id)"
              >账号删除</a
              >
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>
    <user-modal-add ref="userModalAdd" />
    <user-modal-edit ref="userModalEdit" />
    <password-modal ref="passwordModal"></password-modal>
  </div>
</template>
<script>
import UserModalAdd from "./UserModalAdd.vue";
import UserModalEdit from "./UserModalEdit.vue";
import {
  indexStandardType,
  taxpayerNature,
  industry

} from "@/utils/dict";
import PasswordModal from "./components/PasswordModal";
import {
  querySystemUserList,
  querySystemUserListByParams,
  updateStatus,
  deleteSystemUser,
} from "@/api/user";
import { querySystemRoleList } from "@/api/role";
import {mapActions} from "vuex";
export default {
  name: "user",
  data() {
    return {
      showSystemName: false,
      loading: false,
      data: [],
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "租户id",
          dataIndex: "tenantId",
          key: "tenantId",
        },
        {
          title: "账号",
          dataIndex: "contactEmail",
          key: "contactEmail",
        },
        {
          title: "企业名称",
          dataIndex: "companyName",
          key: "companyName",
        },
        {
          title: "联系人",
          dataIndex: "contactPerson",
          key: "contactPerson",
        },
        {
          title: "联系电话",
          dataIndex: "contactMobile",
          key: "contactMobile",
          scopedSlots: { customRender: "contactMobile" },
        },
        {
          title: "纳税人识别号",
          key: "taxpayerNo",
          dataIndex: "taxpayerNo",
          align: "center",
          scopedSlots: { customRender: "taxpayerNo" },
        },
        {
          title: "指标准则类型",
          key: "indexStandardType",
          dataIndex: "indexStandardType",
          align: "center",
          scopedSlots: { customRender: "indexStandardType" },
        },
        {
          title: "纳税人性质",
          key: "taxpayerNature",
          dataIndex: "taxpayerNature",
          align: "center",
          scopedSlots: { customRender: "taxpayerNature" },
        },
        {
          title: "所属行业",
          key: "industry",
          dataIndex: "industry",
          align: "center",
          scopedSlots: { customRender: "industry" },
        },
        {
          title: "账号类型",
          dataIndex: "type",
          key: "type",
          scopedSlots: { customRender: "type" },
        },
        {
          title: "税智报",
          dataIndex: "clientType",
          key: "clientType",
          customRender: function (text) {
            if (text == 1) {
              return "开通";
            }else{
              return "禁用";
            }
          },
        },

        {
          title: "状态",
          key: "status",
          dataIndex: "status",
          align: "center",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
          align: "center",
          scopedSlots: { customRender: "createTime" },
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      current: 1,
      pageSize: 10,
      total: 0,
      roleList: [],
      selectedRowKeys: [],
      selectedRows: [],
      systemName: ""
    };
  },
  components: { UserModalAdd, PasswordModal, UserModalEdit },
  async created() {
    await this.getUserInfo();
    await this.queryRoleList();
    await this.queryList();

  },
  methods: {
    ...mapActions(["Login", "GetUserInfo"]),
    async getUserInfo() {
      let res = await this.GetUserInfo();
      if (res.data.type == 1) {
        this.showSystemName = true;
      }
    },
    async queryRoleList() {
      this.loading = true;
      let res = await querySystemRoleList({
        page: 1,
        pageSize: 100,
      });
      if (res.status == 200) {
        this.roleList = res.data.rows;
      } else {
        let msg = res.msg || res.message;
        let len = msg.length;
        this.$notification.error({
          message: "系统提示",
          description: len > 100 ? "系统错误，请联系管理员" : msg,
          duration: 4,
        });
      }
      this.loading = false;
    },
    statusFormatter(status) {
      if (status == 1) {
        return "启用";
      } else {
        return "禁用";
      }
    },
    indexStandardTypeFormatter(value) {
      const type = indexStandardType.find(item => item.value == value);
      return type? type.label : "未知";
    },
    taxpayerNatureFormatter(value) {
      const type = taxpayerNature.find(item => item.value == value);
      return type ? type.label : "未知"; // 如果没有找到，返回"未知"
    },
    industryFormatter(value) {
      const type = industry.find(item => item.value == value);
      return type ? type.label : "未知"; // 如果没有找到，返回"未知"
    },
    typeFormatter(value) {
      if (value == 1) {
        return "超级管理员";
      } else if (value == 2) {
        return "普通用户";
      }else if (value == 3) {
        return "普通管理员";
      }
    },

    async queryList() {
      this.loading = true;
      if(this.showSystemName){
        let res = await querySystemUserListByParams({
          page: this.current,
          pageSize: this.pageSize,
          accountType: this.systemName
        });

        if (res.status == 200) {
          this.data = res.data.rows;
          this.total = res.data.records;
        } else {
          let msg = res.msg || res.message;
          let len = msg.length;
          this.$notification.error({
            message: "系统提示",
            description: len > 100 ? "系统错误，请联系管理员" : msg,
            duration: 4,
          });
        }

      }else {
        let res = await querySystemUserList({
          page: this.current,
          pageSize: this.pageSize
        });

        if (res.status == 200) {
          this.data = res.data.rows;
          this.total = res.data.records;
        } else {
          let msg = res.msg || res.message;
          let len = msg.length;
          this.$notification.error({
            message: "系统提示",
            description: len > 100 ? "系统错误，请联系管理员" : msg,
            duration: 4,
          });
        }
      }

      this.loading = false;
    },
    handleDelete(id) {
      const that = this;
      this.$confirm({
        title: "确认删除",
        content: "是否删除当前用户,删除前请确认用户是否已经禁用?",
        onOk: async function () {
          let res = await deleteSystemUser({ id: id });
          if (res.status == 200) {
            that.$message.success("删除成功");
            that.queryList();
          } else {
            that.$notification.error({
              message: "系统提示",
              description: res.msg || res.message,
              duration: 4,
            });
          }
        },
      });
    },

    handleAdd() {
      this.$refs.userModalAdd.show();

    },
    handleEdit(record) {
      this.$refs.userModalEdit.show(record);
    },
    async handleStatusChange(id, status) {
      let res = await updateStatus({
        id: id,
        status: status,
      });
      if (res.status == 200) {
        this.queryList();
        this.$message.success("修改成功！");
      } else {
        let msg = res.msg || res.message;
        let len = msg.length;
        this.$notification.error({
          message: "系统提示",
          description: len > 100 ? "系统错误，请联系管理员" : msg,
          duration: 4,
        });
      }
    },
    handleTableChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.total = pagination.total;
      this.queryList();
    },
    handleUpdatePsd() {
      if (this.selectedRows.length != 1) {
        return this.$message.warning("请选择一条数据！");
      }
      this.$refs.passwordModal.show(this.selectedRows[0].id);
    },
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
          this.selectedRows = selectedRows;
        },
      };
    },
  },
  watch: {
    systemName: {
      handler() {
        this.current = 1;
        this.queryList();
      },
      immediate: false
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-tag {
  margin: 0;
}
.container {
  padding: 20px;
  background: #fff;
  min-height: 280px;
}
.options {
  padding-bottom: 16px;
}
.ant-input {
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  font-size: 14px;
  margin-right: 8px;
}
</style>
